import { createRoot } from 'react-dom/client';
import { theme } from './theme';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { App } from './App';

const root = createRoot(document.getElementById('app'));

root.render(
    <ThemeProvider theme={theme}>
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<App />} />
            </Routes>
        </BrowserRouter>
    </ThemeProvider>
);
